import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home'
import Homekind from '../views/homekind/Homekind'
import SolusiIT from '../views/solusi-it/SolusiIT'
import About from '../views/about/About'
import Projects from '../views/projects/Projects'
import Contact from '../views/contact/Contact'
import Services from '../views/services/Services'
import Privacy from '@/views/privacy/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/homekind',
    name: 'Homekind',
    component: Homekind
  },
  {
    path: '/solusi-it',
    name: 'Solusi IT',
    component: SolusiIT
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: Privacy
  }
]

// Navbar height, so anchored sections are not hidden behind the fixed header
const NAV_OFFSET = 80
// Matches the out-in fade in App.vue, so the target section exists before scrolling
const PAGE_TRANSITION_MS = 450

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (!to.hash) return { x: 0, y: 0 }

    const delay = to.path === from.path ? 0 : PAGE_TRANSITION_MS
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ selector: to.hash, offset: { x: 0, y: NAV_OFFSET }, behavior: 'smooth' })
      }, delay)
    })
  }
})

export default router
